import type { BalanceSummary } from '../api/wallet.contract'

export type WithdrawalExperience = 'ON_REQUEST'

export function withdrawalExperience(): WithdrawalExperience {
  return 'ON_REQUEST'
}

export function balanceName(balance: Pick<BalanceSummary, 'currency'>): string {
  return `Saldo em ${balance.currency}`
}

export function experienceLabel(): string {
  return 'Recebimentos automáticos Stripe'
}

export function nextReleaseDate(balance: BalanceSummary): string | null {
  const next = [...balance.nextReleases].sort((left, right) =>
    left.date.localeCompare(right.date),
  )[0]
  if (!next) return null
  return new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    timeZone: 'UTC',
  }).format(new Date(next.date))
}

export function bucketKey(balance: Pick<BalanceSummary, 'currency'>) {
  return balance.currency
}
